/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import withStyles from '@mui/styles/withStyles';
import KyteTecEmailRegistrationContent from "./KyteTecEmailRegistrationContent";
import KyteTecEmailSuccess from "./KyteTecEmailSuccess";
import { SEND_KYTE_TEC_INVITE } from "../../queries/mutations";
import { useMutation } from "@apollo/client";

const topOffset = "10%";
const styles = (theme) => ({
  root: {
    background: "white",
    minHeight: "100vh",
  },
  kyteTecRegistration: {
    position: "fixed",
    width: "100vw",
    top: topOffset,
    background: "linear-gradient(#4396e6, #a5d6e7)",
    borderRadius: "15px 15px 0px 0px",
    zIndex: 100,
    boxShadow: "2px 2px 8px grey",
    maxHeight: "100vh",
    overflowY: "auto",
  },
});

function KyteTecEmailRegistrationModal({ classes, setShowKyteTecEmailModal, setShowPurchaseModal }) {
  const [status, setStatus] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const submitHandler = (event) => {
    event.preventDefault();
    let email = event.target.elements[0].value;
    sendKyteTecInviteMutation({
      variables: {
        emailAddress: email,
      },
    });
  };

  const [sendKyteTecInviteMutation] = useMutation(SEND_KYTE_TEC_INVITE, {
    onCompleted(data) {
      setStatus(data.sendKyteTecInvite.isSuccess);
    },
    onError: (data) => {
      console.log("error", data);
    },
  });

  useEffect(() => {
    if (status) {
      setSuccessMessage(true);
      setTimeout(() => {
        setShowKyteTecEmailModal(false);
      }, 5000);
    }
  }, [status]);

  return (
    <div id="scrollable-modal" className={classes.root}>
      <div className={classes.kyteTecRegistration}>
        {!successMessage && (
          <KyteTecEmailRegistrationContent
            classes={classes}
            setShowPurchaseModal={setShowPurchaseModal}
            setShowKyteTecEmailModal={setShowKyteTecEmailModal}
            submitHandler={submitHandler}
          />
        )}
        {successMessage && (
          <KyteTecEmailSuccess
            classes={classes}
            setShowKyteTecEmailModal={setShowKyteTecEmailModal}
          />
        )}
      </div>
    </div>
  );
}

export default withStyles(styles)(KyteTecEmailRegistrationModal);
